import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { SubjectModel } from '@/models/taxonomy/subject';
import { competencyAPI } from '@/providers/apis/competency/competency';
import { FacetMatrix } from '@/models/proficiency/facet-matrix';
import { FacetMatrixCount } from '@/models/proficiency/facet-matrix-count';
import { sortByProperty } from '@/utils/utils';
import * as d3 from 'd3';
import { FacetCompetenciesCount } from '@/models/proficiency/facet-competencies-count';
import { isNumeric } from '@/utils/math';

@Component({
    name: 'learner-facts',
    components: {

    },
})

export default class LearnerFacts extends Vue {

    @Prop()
    private userId!: string;

    @Prop()
    private month!: string;

    @Prop()
    private year!: string;

    private facetsCompetencyMatrix: FacetMatrix[] = [];

    private facetsCompetencyMatrixData: any;

    private maxFacetCompetenciesCount: number = 0;

    private maxMasterCount: number = 0;

    private skylinePoints: any = [];

    private activeFacet: any = {};

    @Prop()
    private facets!: SubjectModel[];

    private unMappedSubject: any = [];

    private facetChartContainer: any = null;

    private skyLineContainer: any = null;

    private isLoading: boolean = false;

    @Prop({default: false})
    private isShowText?: boolean;

    @Prop({default: 150})
    private fixedWidth?: any;

    @Prop({default: 100})
    private fixedHeight?: any;

    get orderFacets() {
      const filterList: any = this.facets.length
        ? this.facets.filter((subject: SubjectModel) => this.unMappedSubject.indexOf(subject.code) === -1)
          .concat(this.facets.filter(
            (subject: SubjectModel) => this.unMappedSubject.indexOf(subject.code) !== -1)) : [];
      if (filterList.length) {
        sortByProperty(filterList, 'title', 'ASC');
      }
      return filterList;
    }

    public mounted() {
      this.isLoading = true;
      this.loadFacetsCompetencyMatrixData();
    }


    private loadFacetsCompetencyMatrixData() {
      const component = this;
      const requestParams = {
        user: component.userId,
        month: Number(component.month),
        year: Number(component.year),
      };
      competencyAPI.fetchAllFacetsCompetencyMatrix(requestParams).then((facetsCompetencyMatrix: FacetMatrix[]) => {
        component.parseFacetsCompetencyMatrix(facetsCompetencyMatrix);
      });
    }

    private parseFacetsCompetencyMatrix(facetsCompetencyMatrix: FacetMatrix[]) {
      const component = this;
      let maxFacetCompetenciesCount = 0;
      let maxMasterCount = 0;
      const parsedFacetsCompetencyMatrix: any =
        facetsCompetencyMatrix.map((facetCompetencyMatrix: FacetMatrix) => {
          const competencyStats = facetCompetencyMatrix.competencyStats;
          let totalCompetenciesCount = 0;
          let masteredCompetenciesCount = 0;
          let inprogressCompetenciescount = 0;
          let notstartedCompetenciescount = 0;
          const competencyStatusCount = competencyStats.map((competencyStat: FacetMatrixCount) => {
            const competencyStatus = competencyStat.competencyStatus;
            const competenciesCount = competencyStat.competencyCount;
            if (competencyStatus >= 2 && competencyStatus <= 5) {
              masteredCompetenciesCount += competenciesCount;
            } else if (competencyStatus === 1) {
              inprogressCompetenciescount += competenciesCount;
            } else {
              notstartedCompetenciescount += competenciesCount;
            }
          });
          const facetCompetenciesCount = [
            {
              status: 'mastered',
              count: masteredCompetenciesCount,
            },
            {
              status: 'inprogress',
              count: inprogressCompetenciescount,
            },
            {
              status: 'notstarted',
              count: notstartedCompetenciescount,
            },
          ];
          let parsedFacetCompetencyMatrix: any = {
            competenciesCount: facetCompetenciesCount,
          };
          maxMasterCount = maxMasterCount < masteredCompetenciesCount ? masteredCompetenciesCount : maxMasterCount;
          parsedFacetCompetencyMatrix = Object.assign(parsedFacetCompetencyMatrix, facetCompetencyMatrix);
          totalCompetenciesCount =
                masteredCompetenciesCount + inprogressCompetenciescount + notstartedCompetenciescount;
          parsedFacetCompetencyMatrix.totalCompetenciesCount = totalCompetenciesCount;
          maxFacetCompetenciesCount = totalCompetenciesCount > maxFacetCompetenciesCount ?
            totalCompetenciesCount :
            maxFacetCompetenciesCount;
          return parsedFacetCompetencyMatrix;
        });
      component.maxMasterCount = maxMasterCount;
      // component.maxFacetCompetenciesCount = maxFacetCompetenciesCount;
      component.facetsCompetencyMatrixData = parsedFacetsCompetencyMatrix;
      // component.$emit('facetsCompetencyMatrix', parsedFacetsCompetencyMatrix);
      this.isLoading = false;
      component.loadChartData();
    }

    private loadChartData() {
      const component = this;
      const facets = component.facets;
      this.skylinePoints = [];
      const facetsCompetencyMatrixData = component.facetsCompetencyMatrixData;
      let maxFacetCompetenciesCount: any = 0;
      const activeFacetsMatrix: FacetMatrix[] | any = facets && facets.map((facet: SubjectModel) => {
        const availableFacets = facetsCompetencyMatrixData && facetsCompetencyMatrixData.find(
          (facetCompetencyMatrix: FacetMatrix) => facetCompetencyMatrix.subjectCode === facet.code);
        if (!availableFacets) {
          this.unMappedSubject.push(facet.code);
        }
        return availableFacets;
      }).filter((items) => items);
      activeFacetsMatrix.map((activeFacetMatrix: FacetMatrix | any) => {
        maxFacetCompetenciesCount = activeFacetMatrix.totalCompetenciesCount > maxFacetCompetenciesCount ?
          activeFacetMatrix.totalCompetenciesCount :
          maxFacetCompetenciesCount;
      });
      sortByProperty(activeFacetsMatrix, 'subjectName', 'ASC');
      component.maxFacetCompetenciesCount = maxFacetCompetenciesCount;
      component.drawFacetsChart(activeFacetsMatrix);
    }

    private drawFacetsChart(activeFacetsMatrix: any) {
      d3.select(this.$el).select('svg').remove();
      const svg = d3.select(this.$el).append('svg');
      svg.attr('width', this.fixedWidth)
         .attr('height', this.fixedHeight)
         .attr('transform', 'translate(0,0)');
      this.facetChartContainer = svg.append('g').attr('id', 'facet-container');
      this.skyLineContainer = svg.append('g').attr('id', 'skyline-group');
      activeFacetsMatrix.forEach((barData: any, seq: number) => {
        this.drawColumn(barData, seq, (this.fixedWidth / activeFacetsMatrix.length));
      });
    }

    private drawColumn(barData: any, seq: number, columnWidth: number) {
        const facetContainer = d3.select(this.$el).select('#facet-container').append('g');
        const textContainer = d3.select(this.$el).select('#facet-container').append('g')
        .attr('class', 'text-group')
        .attr('transform', `translate(${columnWidth * seq}, 5) rotate(90)`);
        let barHeight = 0;
        barData.competenciesCount.forEach((item: any) => {
          let cellHeight = item.count;
          if (this.maxFacetCompetenciesCount > this.fixedHeight) {
            cellHeight = (item.count / this.maxFacetCompetenciesCount) * this.fixedHeight;
          }

          if (item.status === 'mastered') {
            this.skylinePoints.push({
              x1: columnWidth * seq,
              y1: cellHeight,
              x2: columnWidth * seq + columnWidth,
              y2: cellHeight ,
            });
          }
          facetContainer
            .append('rect')
            .attr('class', item.status)
            .attr('x', seq * columnWidth)
            .attr('y', barHeight)
            .attr('width', columnWidth)
            .attr('height', cellHeight);

          barHeight += cellHeight;
        });

        if (this.isShowText) {
          const fb = textContainer.append('foreignObject')
                    .attr('width', 200)
                    .attr('height', columnWidth)
                    .attr('y', - columnWidth);

          fb.append('xhtml:div')
            .append('div')
            .attr('class', 'text-item')
            .html(barData.subjectName);
        }

        this.drawSkyline();
    }


    private drawSkyline() {
      const component = this;
      const skylineGroup = d3.select(this.$el).select('#skyline-group');
      const skylinePoints = component.skylinePoints;
      let points = '';
      skylinePoints.map((skylinePoint: any) => {
        points += ` ${skylinePoint.x1},${skylinePoint.y1} ${skylinePoint.x2},${skylinePoint.y2}`;
      });
      skylineGroup.append('polyline')
        .attr('points', points)
        .attr('class', 'skyline');
    }

    private selectFacet(facetData: any) {
      const component = this;
      this.activeFacet = component.facets.find(
        (facet: SubjectModel) => facet.code === facetData.subjectCode);
      this.$emit('onSelectSubject', this.activeFacet);
    }

}
